export default "__VITE_ASSET__COuauIHI__"